import { render, staticRenderFns } from "./NoteDetailsVersionsList.vue?vue&type=template&id=514fb909&scoped=true&"
import script from "./NoteDetailsVersionsList.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsVersionsList.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsVersionsList.vue?vue&type=style&index=0&id=514fb909&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514fb909",
  null
  
)

export default component.exports